// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Options = require('./options').Options;
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const { animateScroll } = require('react-scroll');
const classNames = require('classnames');
const cryptoJS = require('crypto-js');
// @ actions
const formActions = require('react-redux-form').actions;
const jointHoldersActions = require('actions/jointHoldersActions');
// @ components
const { InnerForm } = require('components/jointHolders/innerForm');
import { FormattedText, formatText } from 'core/i18n';
const OtpViewHC = require('components/jointHolders/OtpViewHC').OtpViewHC;
// @ utilities
const ClientIcon = require('assets/icons/headline/hazte_cliente.svg');
const { recordEvent, PAGE_PRODUCT } = require('utilities/uTagging');
const { PATH_ADD_JOINHOLDER } = require('constants/uTagConstants/paths');
const StringHelper = require('utilities/stringHelper');
// @constants
const { COUNTRY_DOCUMENT_TYPE_DNI_LABEL } = require('constants/multiLanguage');

require('sass/blocks/_card-detail.scss');

class Detail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invitationSent: true,
        };
        this.onHandleAdd = this.onHandleAdd.bind(this);
        this.onHandleEdit = this.onHandleEdit.bind(this);
        this.runAnimation = this.runAnimation.bind(this);
        this.buildOldData = this.buildOldData.bind(this);
        this.handleOnDelete = this.handleOnDelete.bind(this);
        this.deleteHolder = this.deleteHolder.bind(this);
        this.updateHolder = this.updateHolder.bind(this);
        this.addHolder = this.addHolder.bind(this);
        this.oldData = {};
        this.getTextStatus = this.getTextStatus.bind(this);
    }

    componentDidMount() {
        const { id, immJointHoldersStatus, userProfile, formActions } = this.props;
        const dni = `${userProfile[`jointholder_${id}_docNumber`]}`;
        const email = `${userProfile[`jointholder_${id}_email`]}`;
        immJointHoldersStatus.get('byOrder').map(holderId => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);
            const holderDNI = immJointHolder.get('docNumber');
            const holderEmail = immJointHolder.get('email');
            if (holderDNI === dni && holderEmail != email) {
                formActions.change('userProfile.jointholder_' + id + '_email', holderEmail);
            }
        });

        this.buildOldData(id);
    }

    onHandleAdd() {
        const { userProfile, formActions, id } = this.props;

        if (!userProfile['jointHolderIsEditing'] || userProfile['jointHolderIsEditing'].indexOf(id) === -1) {
            formActions.push('userProfile.jointHolderIsEditing', id); // Array of cards completed, enabled to edit.
        }
        if (userProfile.status !== 'waiting') {
            formActions.change('userProfile.jointHolderEditable', false);
            this.runAnimation(id);
        }
    }

    onHandleEdit(id) {
        this.props.formActions.setValidity('userProfile.jointHolderAuthorizedList', { required: true });
        this.runAnimation(id);
    }

    handleCancel = () => {
        const { userProfile, formActions, id } = this.props;
        const editingIndex = userProfile['jointHolderIsEditing'] ? userProfile['jointHolderIsEditing'].indexOf(id) : -1;

        formActions.change('userProfile.jointHolderEditable', false);
        formActions.setValidity('userProfile.jointholder_' + id + '_docNumber', { duplicated: true });
        formActions.setValidity('userProfile.jointholder_' + id + '_email', { duplicated: true });

        if (editingIndex === -1) {
            const index = userProfile['jointHolderCount'].indexOf(id);
            formActions.remove('userProfile.jointHolderCount', index);
            formActions.change('userProfile.jointholder_' + id + '_name', '');
            formActions.change('userProfile.jointholder_' + id + '_lastName', '');
            formActions.change('userProfile.jointholder_' + id + '_secondLastName', '');
            formActions.change('userProfile.jointholder_' + id + '_documentType', '');
            formActions.change('userProfile.jointholder_' + id + '_docNumber', '');
            formActions.change('userProfile.jointholder_' + id + '_accountType', '');
            formActions.change('userProfile.jointholder_' + id + '_email', '');
            // Reset validations
            formActions.setValidity('userProfile.jointholder_' + id + '_name', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_lastName', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_secondLastName', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_documentType', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_docNumber', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_docNumber', { duplicated: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_accountType', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_email', { required: true });
            formActions.setValidity('userProfile.jointholder_' + id + '_email', { duplicated: true });
        }
    };

    dniFormatNumber(number, documentType) {
        let docNumber = number;

        if (documentType === COUNTRY_DOCUMENT_TYPE_DNI_LABEL) {
            const nZeros = 9 - docNumber.length;
            for (let i = 0; i < nZeros; i++) {
                docNumber = '0' + docNumber;
            }
        }
        return docNumber;
    }

    addHolder(sendPendingMails) {
        const { userProfile, id, jointHoldersActions } = this.props;
        const modelProp = 'jointholder_' + id + '_';

        jointHoldersActions.add(
            {
                inviteDto: {
                    docNumber: this.dniFormatNumber(
                        userProfile[modelProp + 'docNumber'],
                        userProfile[modelProp + 'documentType']
                    ),
                    docType: userProfile[modelProp + 'documentType'],
                    email: userProfile[modelProp + 'email'],
                    jointHolderType: userProfile[modelProp + 'accountType'],
                    openDebitCard: userProfile[modelProp + 'openDebitCard'],
                    lastname1: StringHelper.toFirstUppercase(userProfile[modelProp + 'lastName']),
                    lastname2: userProfile[modelProp + 'secondLastName']
                        ? StringHelper.toFirstUppercase(userProfile[modelProp + 'secondLastName'])
                        : '',
                    name: StringHelper.toFirstUppercase(userProfile[modelProp + 'name']),
                },
            },
            userProfile.accessToken,

            valid => {
                if (valid) {
                    sendPendingMails();
                }
            }
        );
    }

    updateHolder(updateStatus) {
        const { userProfile, id, jointHoldersActions } = this.props;
        const modelProp = 'jointholder_' + id + '_';
        const docType = StringHelper.changeDocType(userProfile[modelProp + 'documentType']);
        const oldDocType = StringHelper.changeDocType(this.oldData.docType);

        jointHoldersActions.save(
            {
                newInvite: {
                    docNumber: this.dniFormatNumber(
                        userProfile[modelProp + 'docNumber'],
                        userProfile[modelProp + 'documentType']
                    ),
                    docType: docType,
                    email: userProfile[modelProp + 'email'],
                    jointHolderType: userProfile[modelProp + 'accountType'],
                    lastname1: StringHelper.toFirstUppercase(userProfile[modelProp + 'lastName']),
                    lastname2: userProfile[modelProp + 'secondLastName']
                        ? StringHelper.toFirstUppercase(userProfile[modelProp + 'secondLastName'])
                        : '',
                    name: StringHelper.toFirstUppercase(userProfile[modelProp + 'name']),
                    openDebitCard: userProfile[modelProp + 'openDebitCard']
                        ? userProfile[modelProp + 'openDebitCard']
                        : false,
                },
                oldInvite: {
                    docNumber: this.oldData.docNumber,
                    docType: oldDocType,
                    email: this.oldData.email,
                    jointHolderType: this.oldData.accountType,
                    openDebitCard: this.oldData.openDebitCard,
                    lastname1: StringHelper.toFirstUppercase(this.oldData.lastName),
                    lastname2: StringHelper.toFirstUppercase(this.oldData.secondLastName),
                    name: StringHelper.toFirstUppercase(this.oldData.name),
                },
            },
            userProfile.accessToken,
            valid => {
                if (valid) {
                    updateStatus();
                }
            }
        );
    }

    deleteHolder(updateStatus) {
        const { userProfile, formActions, id, jointHoldersActions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const modelProp = 'jointholder_' + id + '_';
        const docType = StringHelper.changeDocType(userProfile[modelProp + 'documentType']);

        jointHoldersActions.remove(
            {
                inviteToRemove: {
                    docNumber: userProfile[modelProp + 'docNumber'],
                    docType: docType,
                    email: userProfile[modelProp + 'email'],
                    jointHolderType: userProfile[modelProp + 'accountType'],
                    lastname1: StringHelper.toFirstUppercase(userProfile[modelProp + 'lastName']),
                    lastname2: userProfile[modelProp + 'secondLastName']
                        ? StringHelper.toFirstUppercase(userProfile[modelProp + 'secondLastName'])
                        : '',
                    name: StringHelper.toFirstUppercase(userProfile[modelProp + 'name']),
                    openDebitCard: userProfile[modelProp + 'openDebitCard']
                        ? userProfile[modelProp + 'openDebitCard']
                        : false,
                },
            },
            userProfile.accessToken,
            valid => {
                if (valid) {
                    const index = userProfile['jointHolderCount'].indexOf(id);

                    formActions.remove('userProfile.jointHolderCount', index);
                    formActions.remove('userProfile.jointHolderIsEditing', index);
                    formActions.change('userProfile.jointholder_' + id + '_name', '');
                    formActions.change('userProfile.jointholder_' + id + '_lastName', '');
                    formActions.change('userProfile.jointholder_' + id + '_secondLastName', '');
                    formActions.change('userProfile.jointholder_' + id + '_documentType', '');
                    formActions.change('userProfile.jointholder_' + id + '_docNumber', '');
                    formActions.change('userProfile.jointholder_' + id + '_accountType', '');
                    formActions.change('userProfile.jointholder_' + id + '_email', '');

                    if (userProfile.jointHolderCount.length === 0) {
                        formActions.resetValidity('jointHolderAuthorizedList');
                    }
                    formActions.change('userProfile.jointHoldersError', false);
                    recordEvent(
                        PATH_ADD_JOINHOLDER,
                        PAGE_PRODUCT,
                        'intervinientes',
                        'eliminar',
                        '',
                        '',
                        '',
                        userProfile.investmentType,
                        docNumberEncrypted
                    );
                    updateStatus();
                }
            }
        );
    }

    runAnimation(id) {
        const currentElement = document.getElementById('jointholder_' + id + '_view');
        const bodyRect = document.body.getBoundingClientRect();
        const elementRect = currentElement.getBoundingClientRect();
        const offset = elementRect.top - bodyRect.top - 90;
        animateScroll.scrollTo(offset, { duration: 500 });
    }

    buildOptionHC() {
        const { userProfile, id, immJointHoldersStatus } = this.props;
        const isStandByHC = immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting';
        const email = `${userProfile[`jointholder_${id}_email`]}`;
        let option;

        return immJointHoldersStatus.get('byOrder').map(holderId => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);
            const holderEmail = immJointHolder.get('email');

            if (email === holderEmail) {
                option = (
                    <Options
                        id={id}
                        modelProp={'jointholder_' + id + '_'}
                        handleOnEdit={this.onHandleEdit}
                        isStandByHC={isStandByHC}
                        editable={immJointHolder.get('editable')}
                        dispensable={immJointHolder.get('dispensable')}
                    />
                );

                return option;
            }
        });
    }

    buildOption() {
        const { id, immJointHoldersStatus, userProfile } = this.props;
        const isStandByHC = immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting';

        if (userProfile.jointHolderInvited) {
            return <span className="icons--icon-jointholder-check"></span>;
        }

        return (
            <Options
                id={id}
                modelProp={`jointholder_${id}_`}
                handleOnEdit={this.onHandleEdit}
                isStandByHC={isStandByHC}
                editable={true}
            />
        );
    }

    getAccountType(accountType) {
        let formattedAccountType = {
            titular: 'jointHolderAccountType-titular',
            cotitular: 'jointHolderAccountType-jointHolder',
            autorizado: 'jointHolderAccountType-authorized',
        };

        return formattedAccountType[accountType];
    }

    buildWithCard(openDebitCard) {
        let block;
        if (openDebitCard) {
            block = (
                <div className="card-detail__tag-container">
                    <div className="card-detail__arrow hidden-xs">
                        <div className="card-detail__arrow-left"></div>
                    </div>
                    <div className="card-detail__content__with-card">
                        <FormattedText value="jointHolderAccountType-withCard" />
                    </div>
                </div>
            );
        }
        return block;
    }

    buildOldData(id) {
        const { userProfile } = this.props;
        const modelProp = 'jointholder_' + id + '_';
        const oldDataHolder = {
            name: userProfile[modelProp + 'name'] ? userProfile[modelProp + 'name'] : '',
            lastName: userProfile[modelProp + 'lastName'] ? userProfile[modelProp + 'lastName'] : '',
            secondLastName: userProfile[modelProp + 'secondLastName'] ? userProfile[modelProp + 'secondLastName'] : '',
            docType: userProfile[modelProp + 'documentType'] ? userProfile[modelProp + 'documentType'] : '',
            docNumber: userProfile[modelProp + 'docNumber'] ? userProfile[modelProp + 'docNumber'] : '',
            email: userProfile[modelProp + 'email'] ? userProfile[modelProp + 'email'] : '',
            accountType: userProfile[modelProp + 'accountType'] ? userProfile[modelProp + 'accountType'] : '',
            openDebitCard: userProfile[modelProp + 'openDebitCard'] ? userProfile[modelProp + 'openDebitCard'] : false,
        };

        this.oldData = oldDataHolder;
    }

    buildOtpBlock(id, actionOTP) {
        return (
            <OtpViewHC
                handleOnCancel={this.handleCancel}
                handleOnAdd={this.onHandleAdd}
                oldData={this.oldData}
                modelProp={'jointholder_' + id + '_'}
                buildOldData={this.buildOldData}
                deleteHolder={this.deleteHolder}
                updateHolder={this.updateHolder}
                addHolder={this.addHolder}
                actionOTP={actionOTP}
                id={id}
            />
        );
    }

    buildInnerForm(key) {
        const { id, position, immJointHoldersStatus, userProfile } = this.props;
        const isStandByHC = immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting';
        let joinHolderStatus;
        let joinHolderEditable;

        immJointHoldersStatus.get('byOrder').map((holderId, index) => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);
            if (index === id - 1) {
                joinHolderStatus = immJointHolder.get('status');
                joinHolderEditable = immJointHolder.get('editable');
            }
        });

        return (
            <div id={key} key={key}>
                <InnerForm
                    modelProp={'jointholder_' + id + '_'}
                    id={id}
                    onCancelAction={this.handleCancel}
                    handleOnAdd={this.onHandleAdd}
                    handleOnEdit={this.onHandleEdit}
                    position={position + 1}
                    joinHolderStatus={joinHolderStatus}
                    isStandByHC={isStandByHC}
                    joinHolderEditable={joinHolderEditable}
                />
            </div>
        );
    }

    buildDetailContent() {
        const { userProfile, id } = this.props;
        const key = `jointholder_${id}_view`;
        const fullName = `${userProfile[`jointholder_${id}_name`]} ${userProfile[`jointholder_${id}_lastName`]} ${
            userProfile[`jointholder_${id}_secondLastName`] ? userProfile[`jointholder_${id}_secondLastName`] : ''
        }`;
        const accountType = `${userProfile[`jointholder_${id}_accountType`]}`;
        const formattedAccountType = this.getAccountType(accountType);
        const documentType = `${userProfile[`jointholder_${id}_documentType`]}:`;
        const docNumber = `${userProfile[`jointholder_${id}_docNumber`]}`;
        const email = `${userProfile[`jointholder_${id}_email`]}`;
        const openDebitCard = userProfile[`jointholder_${id}_openDebitCard`];
        const card_detail = classNames('card-detail__options', { icons__disabled: userProfile.jointHolderEditable });
        let docType = StringHelper.changeDocType(documentType);

        let detailContent = (
            <div className={'card-detail'} id={key} key={key}>
                <div className="card-detail__content">
                    <h5>
                        <span className="card-detail__content__title">{fullName}</span>
                        <span className="card-detail__content__title-dash">-</span>
                        <span className="card-detail__content__subtitle">
                            <FormattedText value={formattedAccountType} />
                        </span>
                        {this.buildWithCard(openDebitCard)}
                    </h5>
                    <h6>
                        <span className="card-detail__content__title-2">{docType}:</span>
                        <span className="card-detail__content__subtitle-2">{docNumber}</span>
                        <span className="card-detail__content__vertical-dash" />
                        <span className="card-detail__content__separator-mobile" />
                        <span className="card-detail__content__title-2">
                            <FormattedText value="jointHolderStatus-email" />
                        </span>
                        <span className="card-detail__content__subtitle card-detail__content__email">{email}</span>
                    </h6>
                </div>
                <div className={card_detail}>{this.buildOption()}</div>
            </div>
        );
        if (userProfile.jointHolderEditable === id) {
            detailContent = this.buildInnerForm(key);
        }

        return detailContent;
    }

    getHolderStatus(email) {
        const { immJointHoldersStatus } = this.props;
        const batchStatus = immJointHoldersStatus.get('batchStatus');
        let statusValue;
        let holderStatus;
        let expiration;
        let expirationStatus;

        if (immJointHoldersStatus.get('fetchSuccess')) {
            immJointHoldersStatus.get('byOrder').map(holderId => {
                const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);
                const holderEmail = immJointHolder.get('email');
                if (holderEmail === email) {
                    holderStatus = immJointHolder.get('status');
                    expiration = immJointHolder.get('expiration');
                }
            });
        }

        if (batchStatus) {
            statusValue = 'jointHolderStatus-batchStatus';
        } else {
            switch (holderStatus) {
                case 'invite sent':
                    statusValue = 'jointHolderStatus-pendingInvite';
                    expirationStatus = formatText('jointHolderStatus-invite', [expiration]);
                    break;
                case 'register':
                case 'additional':
                case 'fioc':
                    statusValue = 'jointHolderStatus-pendingCompleteData';
                    break;
                case 'waiting':
                case 'ready':
                    statusValue = 'jointHolderStatus-completed';
                    break;
                case 'batch':
                    statusValue = 'jointHolderStatus-batchStatus';
                    break;
                case 'created':
                case 'identification':
                case 'identified':
                case 'contract':
                case 'signed':
                case 'documentation':
                    statusValue = 'jointHolderStatus-inProcess';
                    break;
                case 'documented':
                case 'standby':
                    statusValue = 'jointHolderStatus-processCompleted';
                    break;
                default:
                    statusValue = '';
            }
        }

        statusValue = statusValue ? formatText(statusValue) : '';

        return (
            <div className="card-detail-hc__content__status-box__current">
                <div>
                    <span>{statusValue}</span>
                </div>
                <span>{expirationStatus}</span>
            </div>
        );
    }

    getFullName(email) {
        const { immJointHoldersStatus } = this.props;
        let fullName;

        if (immJointHoldersStatus.get('fetchSuccess')) {
            immJointHoldersStatus.get('byOrder').map(holderId => {
                const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);
                const holderEmail = immJointHolder.get('email');
                if (holderEmail === email) {
                    fullName = immJointHolder.get('name');
                }
            });
        }

        return fullName;
    }

    getTextStatus(email) {
        const { immJointHoldersStatus } = this.props;
        let status;

        if (immJointHoldersStatus.get('fetchSuccess')) {
            immJointHoldersStatus.get('byOrder').map(holderId => {
                const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);
                const holderEmail = immJointHolder.get('email');
                if (holderEmail === email) {
                    status = immJointHolder.get('status');
                }
            });
        }
        if (status === 'documentation') {
            status = formatText('jointHolderStatus-inProcess');
        }
        return status;
    }

    handleOnDelete() {
        const { formActions, id } = this.props;
        const deleteOPT = 'deleteOPT_' + id;
        formActions.change('userProfile.jointHolderEditable', deleteOPT);
        this.buildDetailContentStandByHC(id);
    }

    buildDeleteBlock(fullName) {
        return (
            <div className="delete-block-hc">
                <FormattedText value="jointHolderStatus-deleteJointHolder" />
                <FormattedText value="jointHolderStatus-deleteJointHolderSubtitle" />
                <ul>
                    <li>{fullName}</li>
                </ul>
                <hr />
                <div className="inner-form__footer--buttons botton-container">
                    <button onClick={this.handleCancel} type="button" className="form__button form__button-negativeB">
                        <FormattedText value="button-cancel" />
                    </button>
                    <button onClick={this.handleOnDelete} className="form__button form__button-primaryB">
                        <FormattedText value="button-delete" />
                    </button>
                </div>
            </div>
        );
    }

    buildDetailContentStandByHC() {
        const { userProfile, id } = this.props;
        const key = `jointholder_${id}_view`;
        const accountType = `${userProfile[`jointholder_${id}_accountType`]}`;
        const formattedAccountType = this.getAccountType(accountType);
        const email = `${userProfile[`jointholder_${id}_email`]}`;
        const fullName = this.getFullName(email);
        const status = this.getHolderStatus(email);
        const textStatus = this.getTextStatus(email);
        let card_detail = classNames('card-detail-hc__icons', { icons__disabled: userProfile.jointHolderEditable });
        if (textStatus === formatText('jointHolderStatus-inProcess')) {
            card_detail = classNames('card-detail-hc__icons--inprocess', {
                icons__disabled: userProfile.jointHolderEditable,
            });
        }
        const standbyHcId = 'standbyhc_' + id;
        const deleteJointHolder = 'deleteJointHolder_' + id;
        const deleteOPT = 'deleteOPT_' + id;
        const addHolderOTP = 'addHolderOTP' + id;
        const emailLenght = 35;

        let detailContent = (
            <div className={'card-detail-hc'} id={key} key={key}>
                <div className="card-detail-hc__content no-margin row">
                    <div className="col-sm-7 col-xs-12 card-detail-hc__content__holder-data no-padding">
                        <div className="card-detail-hc__content__icon">
                            <img src={ClientIcon} alt="" />
                        </div>
                        <div className="card-detail-hc__content__name-box">
                            <div className="card-detail-hc__content__name-box__name">{fullName}</div>
                            <div className="card-detail-hc__content__name-box__type">
                                <FormattedText value={formattedAccountType} />
                                <span> - </span>
                                {StringHelper.cutStringOverflow(email, emailLenght, '...')}
                            </div>
                        </div>
                    </div>
                    <div className="card-detail-hc__content__status-box">{status}</div>
                    <div className={card_detail}>{this.buildOptionHC()}</div>
                </div>
            </div>
        );

        if (userProfile.jointHolderEditable === id) {
            detailContent = this.buildInnerForm(key);
        }

        if (userProfile.jointHolderEditable === standbyHcId) {
            detailContent = this.buildOtpBlock(id, 'edit');
            formActions.change('userProfile.showOTP', true);
            formActions.change('userProfile.showJointHolder', false);
        }

        if (userProfile.jointHolderEditable === deleteJointHolder) {
            detailContent = this.buildDeleteBlock(fullName);
        }

        if (userProfile.jointHolderEditable === deleteOPT) {
            detailContent = this.buildOtpBlock(id, 'delete');
            formActions.change('userProfile.showOTP', true);
            formActions.change('userProfile.showJointHolder', false);
        }

        if (userProfile.jointHolderEditable === addHolderOTP) {
            detailContent = this.buildOtpBlock(id, 'add');
            formActions.change('userProfile.showOTP', true);
            formActions.change('userProfile.showJointHolder', false);
        }

        return detailContent;
    }

    render() {
        const { userProfile, immJointHoldersStatus } = this.props;
        let detailContent =
            immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting'
                ? this.buildDetailContentStandByHC()
                : this.buildDetailContent();

        return detailContent;
    }
}

Detail.proptypes = {
    editable: PropTypes.bool,
};

Detail.defaultProps = {
    editable: true,
};

module.exports.Detail = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immJointHoldersStatus: state.jointHoldersStatus,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
    })
)(Detail);
